<nz-select
  class="app-account-select"
  [nzSize]="nzSize"
  [nzPlaceHolder]="nzPlaceHolder"
  [nzCustomTemplate]="showIbanInPaymentAccountSelection ? accountSelectTemplateWithIban : accountSelectTemplate"
  [compareWith]="accountCompareFn"
  [formControl]="formControl"
>
  @for (account of visibleAccounts$ | async; track account.iban + ':' + account.currency) {
  <nz-option nzCustomContent [nzValue]="account" [nzDisabled]="!isAccountSelectable(account)">
    <div class="app-account-select-option" data-cy="payment-account-option" [attr.data-currency]="account.currency">
      <span class="app-account-select-option-name" nz-text>
        {{ account.description || (account.accountName + ' ' + ('account.accountList.accountName' | translate: locale.language)) }}
      </span>
      <span class="app-account-select-option-amount" data-cy="payment-account-option-amount">
        {{ account.availableFunds | currencySymbol: account.currency | currencyRight }}
      </span>
    </div>
    @if (showIbanInPaymentAccountSelection) {
    <span class="app-account-select-option-iban">{{ account.iban }}</span>
    }
  </nz-option>
  }
</nz-select>

<ng-template #accountSelectTemplateWithIban let-selected>
  <div class="app-account-select-option-selected">
    <div class="app-account-select-option-left">
      <span class="app-account-select-option-name" nz-text>
        {{ selected.nzValue.description ? selected.nzValue.description : (selected.nzValue.accountName + ' ' + ('account.accountList.accountName' | translate:
        locale.language)) }}
      </span>
      <span class="app-account-select-option-iban-selected">{{ selected.nzValue.iban }}</span>
    </div>
    <div class="app-account-select-option-right">
      <span class="app-account-select-option-amount"> {{ selected.nzValue.availableFunds | currencySymbol: selected.nzValue.currency | currencyRight }} </span>
    </div>
  </div>
</ng-template>

<ng-template #accountSelectTemplate let-selected>
  <div class="app-account-select-option">
    <span class="app-account-select-option-name" nz-text>
      {{ selected.nzValue.description ? selected.nzValue.description : (selected.nzValue.accountName + ' ' + ('account.accountList.accountName' | translate:
      locale.language)) }}
    </span>
    <span class="app-account-select-option-amount"> {{ selected.nzValue.availableFunds | currencySymbol: selected.nzValue.currency | currencyRight }} </span>
  </div>
</ng-template>
